/**
 * NF-025 / AC-078: the OS reduce-motion setting, for motion started from
 * script - `scrollIntoView({ behavior: "smooth" })` is not reached by the CSS
 * rule in index.css. Read at the moment of use, so a setting changed while the
 * app is open applies to the next scroll.
 */
export function prefersReducedMotion(
  media: ((query: string) => { matches: boolean }) | undefined = typeof window !== "undefined"
    ? window.matchMedia?.bind(window)
    : undefined,
): boolean {
  return media?.("(prefers-reduced-motion: reduce)").matches ?? false;
}

/** The scroll behaviour to ask for: smooth only when motion is welcome. */
export function scrollBehavior(reduced: boolean = prefersReducedMotion()): ScrollBehavior {
  return reduced ? "auto" : "smooth";
}
